import { taskStateAuditLogEntriesSchema } from "@models";
import { useQuery } from "@tanstack/react-query";
import { getTaskStateActivityQueryKey } from "../../config";
import { getTaskStateActivity } from "../../services";

export const getTaskStateActivityParams = ({
  orgId,
  deviceId,
  taskStateId,
  enabled = true,
}: {
  orgId: string;
  deviceId: string;
  taskStateId: string;
  enabled?: boolean;
}) => {
  return {
    queryKey: getTaskStateActivityQueryKey(orgId, deviceId, taskStateId),
    queryFn: async () => {
      const { data, status } = await getTaskStateActivity(
        orgId,
        deviceId,
        taskStateId
      );
      if (status !== 200) {
        return [];
      }
      const entries = await taskStateAuditLogEntriesSchema.validate(data);
      return entries ?? [];
    },
    enabled,
  };
};

export const useGetTaskStateActivity = ({
  orgId,
  deviceId,
  taskStateId,
  enabled = true,
}: {
  orgId: string;
  deviceId: string;
  taskStateId: string;
  enabled?: boolean;
}) => {
  return useQuery(
    getTaskStateActivityParams({ orgId, deviceId, taskStateId, enabled })
  );
};
